import React, { Component } from "react";
import Logout from "../../assets/logout.svg";
import Back from "../../assets/back.svg";
import Plus from "../../assets/plus.svg";
import RulesEditButton from "../../components/RulesEditButton";
import ListViewer from "../../components/ListViewer";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { NumericFormat } from "react-number-format";
import CustomButton from "../../components/CustomButton";
import { Modal, Form } from "react-bootstrap";
import Cancel from "../../assets/cancel.svg";
import Tick from "../../assets/tick.svg";
import { WhisperSpinner } from "react-spinners-kit";
import { toast } from "react-toastify";
import Paginator from "../../components/Paginator";
import {
  BaseUrl,
  Authorization,
  isUser,
  LogoutFunction,
  ClubAuthorization,
} from "../../static.js";
import "../../App1.css";
import Tooltip from "@mui/material/Tooltip";

export default class MessagePatterns extends Component {
  constructor(props) {
    super(props);

    this.state = {
      gridLocaleText: {
        selectAll: "انتخاب همه",
        selectAllSearchResults: "انتخاب همه نتایج جستجو",
        searchOoo: "جستجو...",
        blanks: "خالی",
        noMatches: "پشدا نشد",
        filterOoo: "فیلتر...",
        equals: "مساوی",
        notEqual: "نا مساوی",
        lessThan: "کمتر از",
        greaterThan: "بیشتر از",
        lessThanOrEqual: "کوچکتر مساوی",
        greaterThanOrEqual: "بزرگتر مساوی",
        inRange: "در محدوده",
        inRangeStart: "به",
        inRangeEnd: "از",
        contains: "شامل",
        notContains: "شامل نباشد",
        startsWith: "شروع با",
        endsWith: "پایان با",
        andCondition: "و",
        orCondition: "یا",
        applyFilter: "تایید",
        resetFilter: "راه اندازی مجدد",
        clearFilter: "پاک کردن",
        cancelFilter: "انصراف",
        columns: "ستون ها",
        filters: "فیلترها",
        group: "گروه",
        loadingOoo: "لطفاً شکیبا باشید...",
        noRowsToShow: "هیچ موردی یافت نشد",
        enabled: "فعال",
        sum: "جمع",
        min: "کمترین",
        max: "بیشترین",
        none: "None",
        count: "تعداد",
        avg: "میانگین",
        filteredRows: "فیلتر شده",
        selectedRows: "انتخاب شده",
        totalRows: "جمع ردیف ها",
        totalAndFilteredRows: "ردیف ها",
        page: "صفحه",
        more: "بیشتر",
        to: "تا",
        of: "از",
        next: "بعدی",
        last: "آخرین",
        first: "اولین",
        previous: "قبلی",
      },
      rowData: [],
      columnDefs: [
        {
          headerName: "متن پیام",
          field: "text",
          sortable: true,
          filter: false,
          resizable: false,
          wrapText: true,
          autoHeight: true,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
            maxWidth: "400px",
          },
          lockPosition: true,
        },
        {
          headerName: "تایید اپراتور",
          field: "isConfirmedBySepand",
          valueFormatter: this.formatActiveContent,
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "نتيجه تاييد",
          field: "resultBySepand",
          cellRenderer: "formatText",
          sortable: true,
          filter: false,
          resizable: false,
          wrapText: true,
          autoHeight: true,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
            maxWidth: "300px",
          },
          lockPosition: true,
        },
        {
          headerName: "تاریخ",
          field: "persianCreatedOn",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "ویرایش",
          field: "id",
          cellRenderer: "fotmatEditCell",
          cellRendererParams: { editItem: this.editItem.bind(this) },
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
      ],
      frameworkComponents: {
        fotmatEditCell: RulesEditButton,
        // formatCurrency: this.formatCurrency,
        formatText: this.formatText,
      },
      ModalShow: false,
      ModalShow2: false,
      modalType: 0,
      writingProgress: false,
      NameErrorText: "",
      NameValue: "",
      IsActive: true,
      MinPurchaseErrorText: "",
      MinPurchaseValue: "",
      CreditErrorText: "",
      CreditValue: "",
      TimeSpanErrorText: "",
      TimeSpanValue: "",
      insideCheck: false,
      packCheck: false,
      sendCheck: false,
      InvoiceServiceType: [],
      AccountGroupIdBatch: [],
      ProductCategoryIdBatch: [],
      dataLoading: true,
      currentPage: 1,
      totalPages: 1,
      groupList: [],
      productList: [],
      currentList: [],
      currentListTypeIsGroup: true,
      messageTextValue: "",
      messageButtons: [
        "@کد تخفیف",
        "@نام مشترک",
        "@نام رستوران",
        "@تاریخ پایان",
        "@مبلغ اعتبار",
      ],
      currentRestaurantId: null,
    };

    this.tableGrid = React.createRef();
    this.tableContainer = React.createRef();
    this.messageInput = React.createRef();

    this.GetSMSTemplates = this.GetSMSTemplates.bind(this);
    this.textHandleChange = this.textHandleChange.bind(this);
    this.resetModalValues = this.resetModalValues.bind(this);
    this.addToMessage = this.addToMessage.bind(this);
    this.checkWord = this.checkWord.bind(this);
    this.checkSign = this.checkSign.bind(this);
  }

  formatText(params) {
    try {
      if (params.value) return params.value;
      else return "-";
    } catch (error) {
      return "-";
    }
  }

  formatServices(params) {
    let text = "";
    params.value.forEach((element) => {
      if (element === 0) {
        if (text === "") text = "داخلی";
        else text += " ، داخلی";
      } else if (element === 1) {
        if (text === "") text = "بسته‌بندی";
        else text += " ، بسته‌بندی";
      } else if (element === 2) {
        if (text === "") text = "ارسال";
        else text += " ، ارسال";
      }
    });
    if (text === "") text = "هیچکدام";
    return text;
  }

  formatCurrency(params) {
    try {
      if (
        params.value === "null" ||
        params.value === "" ||
        params.value === 0 ||
        params.value === null
      )
        return "-";
      // const aa=(params.value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return (
        <NumericFormat
          value={params.value}
          displayType={"text"}
          thousandSeparator={true}
          suffix={" ریال"}
        />
      );
      //return <div style={{display:'flex',flexDirection:'row'}}><div>ریال&nbsp;</div><NumericFormat style={{fontFamily:'SFUIDisplayBold'}} value={params.value} displayType={'text'} thousandSeparator={true}/></div>
    } catch (error) {
      return "-";
    }
  }

  formatActiveContent(params) {
    if (params.value) return "تایید شده";
    else return "تایید نشده";
  }

  fotmatEditCell(params) {
    return;
  }

  getBusinessInfo() {
    let data = {
      businessCode: this.props.match.params.id,
    };
    data = Object.assign(data, Authorization());

    fetch(BaseUrl + "findBusinessWithCode", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.status === 200) {
          this.setState({ currentRestaurantId: result.result[0].id }, () => {
            this.GetSMSTemplates(1);
          });
        } else if (result.status === 401) {
          LogoutFunction();
        }
        // console.log("findBusinessWithCode:", result);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  componentDidMount() {
    this.getBusinessInfo();
  }

  GetSMSTemplates(page) {
    this.setState({ dataLoading: true });

    let data = isUser
      ? {
          businessCode: this.props.match.params.id,
        }
      : {};
    data = Object.assign(data, ClubAuthorization());
    let jsonString = "SepandPlus " + btoa(JSON.stringify(data));

    fetch(
      "https://94.101.187.196/api/SMSTemplate/GetSMSTemplates?restaurantId=" +
        this.state.currentRestaurantId +
        "&smsTypeId=1&page=" +
        page,
      {
        method: "GET",
        headers: { Authorization: jsonString },
      }
    )
      .then((res) => {
        if (res.status === 401) {
          LogoutFunction();
        } else {
          console.log(res);
          return res.json();
        }
      })
      .then((result) => {
        console.log(result);
        if (!result.isSuccessfull) {
          toast.error(result.errorMessage, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        }

        this.setState({
          dataLoading: false,
          rowData: result.results[0].pageData,
          currentPage: result.results[0].currentPage,
          totalPages: result.results[0].totalPages,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ dataLoading: false });
      });
  }

  onFirstPageClick() {
    this.GetSMSTemplates(1);
  }

  onPreviousPageClick() {
    this.GetSMSTemplates(this.state.currentPage - 1);
  }

  onNextPageClick() {
    this.GetSMSTemplates(this.state.currentPage + 1);
  }

  onLastPageClick() {
    this.GetSMSTemplates(this.state.totalPages);
  }

  onBack() {
    this.props.history.push(
      "/Restaurants/" + this.props.match.params.id + "/Club"
    );
  }

  onLogout() {
    LogoutFunction();
  }

  onFirstDataRendered(params) {
    try {
      params.api.sizeColumnsToFit();
      window.setTimeout(() => {
        const colIds = params.columnApi.getAllColumns().map((c) => c.colId);
        params.columnApi.autoSizeColumns(colIds, false);

        let cols = this.tableGrid.current.columnApi.getColumnState();
        let width = 0;
        cols.forEach((element) => {
          width += element.width;
        });

        // console.log('width',width);
        // console.log('tableContainer',this.tableContainer.current.getBoundingClientRect().width-10);
        if (
          width <
          this.tableContainer.current.getBoundingClientRect().width - 10
        ) {
          let def =
            this.tableContainer.current.getBoundingClientRect().width -
            10 -
            width;
          // console.log('def',def);
          if (def > cols.length) {
            let newwidth = def / cols.length;
            // console.log('newwidth',newwidth)
            cols.forEach((element) => {
              params.columnApi.setColumnWidth(
                element.colId,
                element.width + newwidth
              );
            });
          } else {
            // console.log('aa');
            params.columnApi.setColumnWidth(cols[0].colId, cols[0].width + def);
          }
        }
        // if (width<this.tableContainer.current.getBoundingClientRect().width) params.api.sizeColumnsToFit()
      }, 50);
    } catch (error) {}
  }

  resetModalValues(id) {
    let messagevalue = "";
    if (id) {
      this.state.rowData.forEach((element) => {
        if (element.id === id) messagevalue = element.text;
      });
    }
    this.setState({
      writingProgress: false,
      messageTextValue: messagevalue,
    });
  }

  onAddNewButton() {
    this.resetModalValues(0);
    this.setState({ ModalShow: true, modalType: 0 }, () => {
      this.messageInput.current.focus();
    });
  }

  editItem(e) {
    this.resetModalValues(e);
    this.setState({ ModalShow: true, modalType: e });
  }

  hideModal() {
    this.setState({ ModalShow: false });
  }

  hideModal2() {
    this.setState({ ModalShow2: false });
  }

  textHandleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  checkWord(text, word) {
    let index = text.indexOf(word);
    if (index > -1) {
      if (
        (text.substring(index - 1, index) !== "" &&
          text.substring(index - 1, index) !== " " &&
          text.substring(index - 1, index) !== "\n") ||
        (text.substring(index + word.length, index + word.length + 1) !== "" &&
          text.substring(index + word.length, index + word.length + 1) !==
            " " &&
          text.substring(index + word.length, index + word.length + 1) !== "\n")
      ) {
        return false;
      } else {
        if (text.substring(index + word.length).length > word.length) {
          return this.checkWord(text.substring(index + word.length), word);
        } else {
          return true;
        }
      }
    } else return true;
  }

  checkSign(text) {
    let index = text.indexOf("@");
    if (index > -1) {
      let found = false;
      this.state.messageButtons.forEach((element) => {
        if (text.substring(index, index + element.length) === element) {
          found = true;
        }
      });

      if (!found) return false;
      else return this.checkSign(text.substring(index + 1));
      // if (found)

      // return true;
    } else return true;
  }

  onConfirm() {
    let error = false;
    this.state.messageButtons.forEach((element) => {
      if (!error && !this.checkWord(this.state.messageTextValue, element)) {
        toast.error(
          "کاراکتر غیرمجاز قبل یا بعد متغیر '" +
            element.substring(1) +
            "'." +
            "\n" +
            "قیل یا بعد از هر متغیر باید کاراکتر فاصله (space) وجود داشته باشد",
          {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          }
        );
        error = true;
      }
    });

    if (!error && !this.checkSign(this.state.messageTextValue)) {
      toast.error(
        "کاراکتر غیرمجاز در بین یکی از متغیرها وجود دارد." +
          "\n" +
          "لطفاً متن متغیرها را مجدد بررسی کنید",
        {
          position: toast.POSITION.BOTTOM_RIGHT,
          hideProgressBar: true,
          autoClose: 8000,
          toastClassName: "toast",
        }
      );
      error = true;
    }

    if (error) return;

    if (this.state.messageTextValue.indexOf("@کد تخفیف") < 0) {
      toast.error("استفاده از کد تخفیف در پیام اجباری است", {
        position: toast.POSITION.BOTTOM_RIGHT,
        hideProgressBar: true,
        autoClose: 8000,
        toastClassName: "toast",
      });
      return;
    }
    // return;

    let data = {
      restaurantId: Number(this.state.currentRestaurantId),
      id: this.state.modalType,
      text: this.state.messageTextValue,
      sMSTypeId: 1,
    };
    let apiname = "";
    if (this.state.modalType === 0) apiname = "AddSMSTemplate";
    else apiname = "EditSMSTemplate";
    console.log(data);

    let data1 = isUser
      ? {
          businessCode: this.props.match.params.id,
        }
      : {};
    data1 = Object.assign(data1, ClubAuthorization());
    let jsonString = "SepandPlus " + btoa(JSON.stringify(data1));

    this.setState({ writingProgress: true });
    fetch("https://94.101.187.196/api/SMSTemplate/" + apiname, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: jsonString,
      },
      body: JSON.stringify(data),
    })
      .then((res) => {
        console.log("res: ", res);
        // console.log("res: ", res.json());
        return res.json();
      })
      .then((result) => {
        console.log(result);
        if (result.isSuccessfull) {
          toast.success(
            this.state.modalType === 0
              ? "الگوی جدید با موفقیت اضافه شد"
              : "الگو مورد نظر با موفقیت ویرایش شد",
            {
              position: toast.POSITION.BOTTOM_RIGHT,
              hideProgressBar: true,
              autoClose: 8000,
              toastClassName: "toast",
            }
          );
          this.setState({ writingProgress: false, ModalShow: false }, () => {
            this.GetSMSTemplates(this.state.currentPage);
          });
        } else if (result.errorMessage) {
          toast.error(result.errorMessage, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
          this.setState({ writingProgress: false });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ writingProgress: false });
      });
  }

  onCustomerGroupsClick() {
    this.setState({
      ModalShow2: true,
      listLoading: true,
      currentListTypeIsGroup: true,
    });

    let data = isUser
      ? {
          businessCode: this.props.match.params.id,
        }
      : {};
    data = Object.assign(data, ClubAuthorization());
    let jsonString = "SepandPlus " + btoa(JSON.stringify(data));

    fetch(
      "https://94.101.187.196/api/AccountGroup/GetAccountGroups?restaurantId=" +
        this.state.currentRestaurantId +
        "&page=0",
      {
        method: "GET",
        headers: { Authorization: jsonString },
      }
    )
      .then((res) => {
        if (res.status === 401) {
          LogoutFunction();
        } else {
          return res.json();
        }
      })
      .then((result) => {
        console.log(result);
        // if (result.isSuccessfull){

        // }else {
        //     this.props.history.push('/Restaurants');
        // }

        if (!result.isSuccessfull) {
          toast.error(result.errorMessage, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        }

        this.setState({
          listLoading: false,
          currentList: result.results[0].items,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ listLoading: false });
      });
  }

  onProductCategory() {
    this.setState({
      ModalShow2: true,
      listLoading: true,
      currentListTypeIsGroup: false,
    });

    let data = isUser
      ? {
          businessCode: this.props.match.params.id,
        }
      : {};
    data = Object.assign(data, ClubAuthorization());
    let jsonString = "SepandPlus " + btoa(JSON.stringify(data));

    fetch(
      "https://94.101.187.196/api/ProductCategory/GetProductCategories?restaurantId=" +
        this.state.currentRestaurantId,
      {
        method: "GET",
        headers: { Authorization: jsonString },
      }
    )
      .then((res) => {
        if (res.status === 401) {
          LogoutFunction();
        } else {
          return res.json();
        }
      })
      .then((result) => {
        console.log(result);
        // if (result.isSuccessfull){

        // }else {
        //     this.props.history.push('/Restaurants');
        // }

        if (!result.isSuccessfull) {
          toast.error(result.errorMessage, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        }

        this.setState({ listLoading: false, currentList: result.results });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ listLoading: false });
      });
  }

  onConfirmGroups(list) {
    console.log(list);
    this.setState({ groupList: list, ModalShow2: false });
    // let temp=JSON.parse(JSON.stringify(this.state.currentList))

    // temp.forEach(element => {
    //     list.forEach(element1 => {
    //         if (element.id===element1.id){

    //         }
    //     });
    // });
  }

  onConfirmProduct(list) {
    this.setState({ productList: list, ModalShow2: false });
  }

  onbtnPattern(name) {
    this.addToMessage(name);
  }

  onbtnPattern1() {
    this.addToMessage("@کد تخفیف");
  }

  onbtnPattern2() {
    this.addToMessage("@نام مشترک");
  }

  onbtnPattern3() {
    this.addToMessage("@نام رستوران");
  }

  onbtnPattern4() {
    this.addToMessage("@تاریخ پایان");
  }

  onbtnPattern5() {
    this.addToMessage("@مبلغ اعتبار");
  }

  addToMessage(text) {
    let caretIndex = this.messageInput.current.selectionStart;

    let start = this.state.messageTextValue.substring(0, caretIndex);

    let end = this.state.messageTextValue.substring(caretIndex);

    if (
      this.state.messageTextValue.substring(caretIndex - 1, caretIndex) !==
        "" &&
      this.state.messageTextValue.substring(caretIndex - 1, caretIndex) !==
        " " &&
      this.state.messageTextValue.substring(caretIndex - 1, caretIndex) !== "\n"
    ) {
      text = " " + text;
    }

    if (
      this.state.messageTextValue.substring(
        caretIndex + text.lenght,
        caretIndex + text.lenght + 1
      ) !== "" &&
      this.state.messageTextValue.substring(
        caretIndex + text.lenght,
        caretIndex + text.lenght + 1
      ) !== " " &&
      this.state.messageTextValue.substring(
        caretIndex + text.lenght,
        caretIndex + text.lenght + 1
      ) !== "\n"
    ) {
      text += " ";
    }

    this.setState({ messageTextValue: start + text + end }, () => {
      this.messageInput.current.focus();
      this.messageInput.current.selectionStart = caretIndex + text.length;
      this.messageInput.current.selectionEnd = caretIndex + text.length;
    });
  }

  render() {
    return (
      <div className="Login">
        <div className="header">
          <div
            onClick={this.onBack.bind(this)}
            className="linkStyle backButton"
          >
            <img
              src={Back}
              alt=""
              className="backButtonIcon"
              style={{ transform: "rotate(180deg)" }}
            />
            بازگشت
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              height: "fit-content",
              alignItems: "center",
            }}
          >
            <Tooltip title="خروج">
              <div
                onClick={this.onLogout.bind(this)}
                className="linkStyle backButton"
              >
                <img src={Logout} alt="" className="backButtonIcon" />
              </div>
            </Tooltip>
          </div>
        </div>
        <div className="LoginContent">
          <div className="RestaurantsListTitle">الگوهای پیام</div>
          <div className="RestaurantsListSubTitle">
            ایجاد و ویرایش الگوهای پیام
          </div>
        </div>
        <div className="pageContents" ref={this.tableContainer}>
          {!this.state.dataLoading && (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                alignItems: "center",
                width: "fit-content",
              }}
            >
              <CustomButton
                title="الگوی جدید"
                imgHeight={20}
                imgWidth={25}
                flexDirection="row-reverse"
                minHeight="35px"
                img={Plus}
                onClick={this.onAddNewButton.bind(this)}
              />
            </div>
          )}
          {!this.state.dataLoading && (
            <div className="tableContainer ag-theme-alpine">
              <AgGridReact
                enableRtl={true}
                autoHeight={true}
                animateRows={true}
                enableBrowserTooltips={true}
                tooltipMouseTrack={true}
                suppressSizeToFit={false}
                columnDefs={this.state.columnDefs}
                localeText={this.state.gridLocaleText}
                rowData={this.state.rowData}
                suppressDragLeaveHidesColumns={true}
                suppressMovable={true}
                skipHeaderOnAutoSize={false}
                // onGridReady={this.onGridReady.bind(this)}
                onFirstDataRendered={this.onFirstDataRendered.bind(this)}
                rowHeight={window.innerWidth <= 587 ? 40 : 50}
                headerHeight={window.innerWidth <= 587 ? 40 : 50}
                frameworkComponents={this.state.frameworkComponents}
                // onRowClicked={this.onGridRowClicked.bind(this)}
                // getRowStyle ={function(params){ return { borderWidth:'0px' }}}
                ref={this.tableGrid}
                enableCellTextSelection={true}
                ensureDomOrder={true}
              ></AgGridReact>
            </div>
          )}
          {!this.state.dataLoading && (
            <div
              style={{
                width: "100%",
                marginTop: "15px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Paginator
                currentPage={this.state.currentPage}
                totalPages={this.state.totalPages}
                onFirstPageClick={this.onFirstPageClick.bind(this)}
                onPreviousPageClick={this.onPreviousPageClick.bind(this)}
                onNextPageClick={this.onNextPageClick.bind(this)}
                onLastPageClick={this.onLastPageClick.bind(this)}
              />
            </div>
          )}

          {this.state.dataLoading && (
            <div
              style={{
                display: "flex",
                width: "100%",
                height: "100%",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <WhisperSpinner
                size={50}
                color="var(--brown1)"
                frontColor="var(--brown1)"
                backColor="var(--brown1)"
                loading={true}
              />
            </div>
          )}
        </div>

        <Modal
          show={this.state.ModalShow}
          size="lg"
          animation={true}
          onHide={this.hideModal.bind(this)}
          centered
        >
          <div className="settingContainer" style={{ padding: "10px" }}>
            <div className="ModalTitleSM">الگوی جدید</div>
            {/* <div className="ModalSubTitle">برای ساخت الگوی جدید پیام متن </div> */}

            <div
              className="message-button-grid"
              // style={{
              //   display: "flex",
              //   flexDirection: "row",
              //   justifyContent: "space-between",
              //   alignItems: "center",
              //   width: "100%",
              //   marginTop: "20px",
              // }}
            >
              {this.state.messageButtons.map((item, i) => {
                return (
                  <div style={{ width: "100%" }} key={i}>
                    <CustomButton
                      title={item}
                      flexDirection="row-reverse"
                      minHeight="35px"
                      onClick={this.onbtnPattern.bind(this, item)}
                    />
                    {/* <div style={{ minWidth: "5px" }} /> */}
                    {/* {i < this.state.messageButtons.length - 1 && (
                      
                    )} */}
                  </div>
                );
              })}
              {/* <CustomButton
                title="@تخفیف"
                flexDirection="row-reverse"
                minHeight="35px"
                onClick={this.onbtnPattern1.bind(this)}
              />
              <div style={{ minWidth: "5px" }} />
              <CustomButton
                title="@نام مشترک"
                flexDirection="row-reverse"
                minHeight="35px"
                onClick={this.onbtnPattern2.bind(this)}
              />
              <div style={{ minWidth: "5px" }} />
              <CustomButton
                title="@نام رستوران"
                flexDirection="row-reverse"
                minHeight="35px"
                onClick={this.onbtnPattern3.bind(this)}
              />
              <div style={{ minWidth: "5px" }} />
              <CustomButton
                title="@تاریخ پایان"
                flexDirection="row-reverse"
                minHeight="35px"
                onClick={this.onbtnPattern4.bind(this)}
              />
              <div style={{ minWidth: "5px" }} />
              <CustomButton
                title="@مبلغ اعتبار"
                flexDirection="row-reverse"
                minHeight="35px"
                onClick={this.onbtnPattern5.bind(this)}
              /> */}
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                // overflow: "auto",
                marginTop: "10px",
                width: "100%",
              }}
            >
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlTextarea1"
              >
                <Form.Control
                  as="textarea"
                  value={this.state.messageTextValue}
                  onChange={(e) =>
                    this.setState({ messageTextValue: e.target.value })
                  }
                  rows={6}
                  maxLength="500"
                  ref={this.messageInput}
                />
              </Form.Group>
            </div>

            <div
              style={{
                width: "100%",
                maxWidth: "500px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop: "20px",
                alignItems: "center",
              }}
            >
              <div style={{ flex: "1" }}>
                <CustomButton
                  title="ذخیره"
                  loading={this.state.writingProgress}
                  imgHeight={20}
                  imgWidth={25}
                  minHeight="35px"
                  img={Tick}
                  onClick={this.onConfirm.bind(this)}
                />
              </div>
              <div style={{ minWidth: "10px" }} />
              <div style={{ flex: "0.8" }}>
                <CustomButton
                  title="انصراف"
                  imgHeight={19}
                  backColor="var(--black1)"
                  imgWidth={25}
                  minHeight="35px"
                  img={Cancel}
                  onClick={this.hideModal.bind(this)}
                />
              </div>
            </div>
          </div>
        </Modal>

        <Modal
          show={this.state.ModalShow2}
          animation={true}
          size="sm"
          backdrop="static"
          backdropClassName="backdropClassName"
          onHide={this.hideModal2.bind(this)}
          centered
        >
          {this.state.ModalShow2 && (
            <ListViewer
              groups={this.state.currentListTypeIsGroup}
              currentSelected={
                this.state.currentListTypeIsGroup
                  ? this.state.groupList
                  : this.state.productList
              }
              list={this.state.currentList}
              loading={this.state.listLoading}
              onConfirmProduct={this.onConfirmProduct.bind(this)}
              onConfirmGroups={this.onConfirmGroups.bind(this)}
              hideModal={this.hideModal2.bind(this)}
            />
          )}
        </Modal>
        {/* <ReactTooltip effect="solid" /> */}
      </div>
    );
  }
}
